import React, {useState} from 'react'
import {Modal} from 'react-bootstrap'

export const ModalWithTrigger = (props) => {
  const [show, setShow] = useState(false)

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  return (
    <>
      <span className='simulated-link' onClick={handleShow}>
        {props.trigger}
      </span>

      <Modal className='generic-modal-window' show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          {props.title && <Modal.Title>{props.title}</Modal.Title>}
        </Modal.Header>
        <Modal.Body>
          <div dangerouslySetInnerHTML={{__html: props.content}} />
        </Modal.Body>
      </Modal>
    </>
  );
}
